// TODO: make both seatch and login use one http library
import request from 'superagent-promise';
import $ from 'jquery';

export default  {
  search (url, searchTerm) {
    // clean the search term
    searchTerm = searchTerm.toLowerCase();
    searchTerm = searchTerm.trim();
    searchTerm = searchTerm.replace(/\s\s+/g, ' ');
    var searchUrl = url + encodeURIComponent(searchTerm);
    return request.get(searchUrl).end();
  },
  logout (url) {
    return $.ajax({
      url,
      type: 'POST'
    });
  }
};



// WEBPACK FOOTER //
// ./frontend/react/api/header.js